import { Inbox } from 'lucide-react';

interface NoDataMessageProps {
  text: string;
  description?: string;
}

const NoDataMessage = ({ text, description }: NoDataMessageProps) => (
  <div className="flex flex-col items-center justify-center py-12 text-gray-400">
    <Inbox className="h-10 w-10 mb-3" />
    <p className="text-sm font-medium text-gray-500">{text}</p>
    {description && <p className="text-xs text-gray-400 mt-1">{description}</p>}
  </div>
);

export default NoDataMessage;
